import React from "react";
import { Menu } from "antd";
import { PieChartOutlined, TeamOutlined } from "@ant-design/icons";
import { useMenu } from "../../../common/contexts/MenuContext";
import { useHistory } from "react-router";

const AdminMenu = () => {
  const { selectedMenu, setSelectedMenu } = useMenu();
  const history = useHistory();
  return (
    <Menu theme="dark" selectedKeys={selectedMenu} mode="vertical">
      <Menu.Item
        key="1"
        icon={<PieChartOutlined />}
        onClick={() => {
          setSelectedMenu(["1"]);
          history.push("/admin/stores");
        }}
      >
        Orders
      </Menu.Item>
      <Menu.Item
        key="2"
        icon={<PieChartOutlined />}
        onClick={() => {
          setSelectedMenu(["2"]);
          history.push("/admin/customers");
        }}
      >
        Customers
      </Menu.Item>
    </Menu>
  );
};

export default AdminMenu;
